import {denormalize, normalize, schema} from 'normalizr';

const zonaEntrega = new schema.Entity('zonasEntrega', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {
    const mySchema = [zonaEntrega];
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {
    const mySchema = zonaEntrega;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {
    const mySchema = zonaEntrega;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

